// Chrome's page translation swaps the text nodes React owns for its own <font>
// nodes. React still holds the originals, so its next commit asks a parent to
// remove or insert relative to a node that parent no longer has, the DOM throws
// NotFoundError, and the page crashes mid-talk (facebook/react#11538).
//
// We tolerate the mismatch rather than set translate="no": hosts who don't read
// English rely on translation to use the controller.
let installed = false;

export const installDomTranslateGuard = () => {
  if (installed) return;
  installed = true;

  const { removeChild, insertBefore } = Node.prototype;

  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T) {
    // Already moved away by the translator: there is nothing left to remove.
    if (child.parentNode !== this) return child;
    return removeChild.call(this, child) as T;
  };

  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    node: T,
    ref: Node | null
  ) {
    // The anchor is gone, so the exact spot is unknowable. The end of the parent
    // keeps the node on the page, which beats crashing.
    if (ref && ref.parentNode !== this) return this.appendChild(node);
    return insertBefore.call(this, node, ref) as T;
  };
};
